import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { PublisherConfigurationResponse } from 'components/common/types/Publisher.types';
import getCountryName from 'utils/countryNameFromISO2';

export interface DspFromMediaOwners {
  publisher: string;
  code: string;
  name: string;
}

export interface MediaOwnerDetails {
  countryName: string;
  identifier: string;
  name: string;
}

export type UnderlyingMediaOwner = {
  [idendifier: string]: MediaOwnerDetails;
};

export interface ResellerState {
  exclusiveDsps: string[];
  underlyingMediaOwners: UnderlyingMediaOwner;
  isInternalPublisher: boolean;
}

const initialState: ResellerState = {
  exclusiveDsps: [],
  underlyingMediaOwners: {},
  isInternalPublisher: false,
};

const resellerSlice = createSlice({
  name: 'reseller',
  initialState,
  reducers: {
    createUnderlyingMediaOwners: (state: ResellerState, action: PayloadAction<string[]>) => {
      return {
        ...state,
        underlyingMediaOwners: action.payload.reduce((acc, identifier) => {
          acc[identifier] = {
            countryName: '',
            identifier,
            name: '',
          };
          return acc;
        }, {} as UnderlyingMediaOwner),
      };
    },
    changeUnderlyingMediaOwners: (state: ResellerState, action: PayloadAction<PublisherConfigurationResponse[]>) => {
      return {
        ...state,
        underlyingMediaOwners: action.payload.reduce((acc, cur) => {
          acc[cur.identifier] = {
            countryName: getCountryName(cur.iso2CountryCode),
            identifier: cur.identifier,
            name: cur.name,
          };
          return acc;
        }, {} as UnderlyingMediaOwner),
      };
    },
    updateResellerState: (state: ResellerState, action: PayloadAction<Partial<ResellerState>>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    clearResellerData: () => {
      return {
        ...initialState,
      };
    },
  },
});

export const { clearResellerData, createUnderlyingMediaOwners, changeUnderlyingMediaOwners, updateResellerState } =
  resellerSlice.actions;
export default resellerSlice.reducer;
